import script from "./AppsTypesList.vue?vue&type=script&setup=true&lang=js"
export * from "./AppsTypesList.vue?vue&type=script&setup=true&lang=js"

import "./AppsTypesList.vue?vue&type=style&index=0&id=0a2626fa&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-0a2626fa"]])

export default __exports__